import { TypeText } from '@modules/oracle/components/FeedbackListSummary/TypeText';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { Box, Stack, Typography } from '@mui/material';
import { FeedbackSummaryUserQuoteToken } from 'generated/graphql';
import { SyntheticEvent, useState } from 'react';
import { createAnalyticsTracker } from 'v2/analytics/events';

const trackFeedbackListSummaryEvents = createAnalyticsTracker(
  'feedbackListSummary',
);

interface UserQuoteTextProps {
  userQuoteTokens: FeedbackSummaryUserQuoteToken[];
}

const MIN_HEIGHT = 120;

export function UserQuoteText({ userQuoteTokens }: UserQuoteTextProps) {
  const [userQuoteTokenIndex, setUserQuoteTokenIndex] = useState(0);

  const onCopy = (event: SyntheticEvent) => {
    event.stopPropagation();
    const selectedText = window.getSelection()?.toString();

    trackFeedbackListSummaryEvents({
      eventName: 'Feedback List Summary - Manual Copy User Quote',
      copiedSummaryText: selectedText,
    });
  };

  if (!userQuoteTokens.length) {
    return (
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        sx={{ minHeight: MIN_HEIGHT }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontStyle: 'italic' }}
        >
          Unable to retrieve user's quote. Click here for a detailed view
        </Typography>
        <ArrowUpwardIcon color="disabled" />
      </Stack>
    );
  }

  return (
    <Stack spacing={1} sx={{ minHeight: MIN_HEIGHT, width: 500 }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
      >
        Quote from the user's feedback
      </Typography>
      <Typography variant="body1" onCopy={onCopy}>
        <Box component="sup" mr={0.25}>
          <FormatQuoteIcon color="disabled" sx={{ rotate: '180deg' }} />
        </Box>
        {userQuoteTokens.map((userQuoteToken, currentUserQuoteTokenIndex) => {
          if (currentUserQuoteTokenIndex > userQuoteTokenIndex) {
            return null;
          }

          return (
            <TypeText
              key={currentUserQuoteTokenIndex}
              text={userQuoteToken.content}
              shouldDisableAnimation={
                currentUserQuoteTokenIndex < userQuoteTokenIndex
              }
              onRenderComplete={() => {
                setUserQuoteTokenIndex(currentUserQuoteTokenIndex + 1);
              }}
            />
            /* {userQuoteTokens.length - 1 === currentUserQuoteTokenIndex && (
                <BlinkCaret key="blink-caret" />
              )} */
          );
        })}
        {userQuoteTokenIndex >= userQuoteTokens.length && (
          <Box component="sup">
            <FormatQuoteIcon color="disabled" />
          </Box>
        )}
      </Typography>
    </Stack>
  );
}
